// @flow
import * as React from 'react'

import './Form.module.scss'

type Props = {
  fill: boolean,
  onSubmit: () => void,
  children: React.Node,
}

type State = {
  errors: {},
  showErrors: boolean,
}

export const FormContext = React.createContext({})

export default class Form extends React.Component<Props, State> {
  static defaultProps = {
    fill: false,
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      errors: {},
      showErrors: false,
    }
  }

  render = () => {
    const modifier = this.props.fill ? 'fill' : ''

    const contextValue = {
      form: {
        showErrors: this.state.showErrors,
        errors: this.state.errors,
        onValidValue: this.handleValidValue,
        onInvalidValue: this.handleInvalidValue,
      },
    }

    return (
      <form styleName={`root ${modifier}`} noValidate onSubmit={this.handleSubmit}>
        <FormContext.Provider value={contextValue}>{this.props.children}</FormContext.Provider>
      </form>
    )
  }

  handleSubmit = (event: Event) => {
    event.preventDefault()

    if (this.hasErrors) return this.setState({ showErrors: true })

    this.setState({ showErrors: false })
    this.props.onSubmit()
  }

  handleValidValue = (name: string) => {
    this.setState(prevState => ({ errors: { ...prevState.errors, [name]: undefined } }))
  }

  handleInvalidValue = (name: string, error: string) => {
    this.setState(prevState => ({ errors: { ...prevState.errors, [name]: error } }))
  }

  get hasErrors(): boolean {
    return Object.values(this.state.errors).some(x => !!x)
  }
}
